<template>
  <div class="evaluate-list">
    <div class="evaluate-box" v-for="(item, index) in dataList" :key="index">
      <div class="user-img">
        <img :src="item.avatar == '' || item.avatar == null
          ? defaultAvatar
          : item.avatar
          " alt="" />
      </div>
      <div class="evaluate-info">
        <div class="name-score">
          <div class=" ">
            {{ item.truename }}
          </div>
          <div class="score">
            <el-rate v-model="item.score" disabled show-score text-color="#D81E06" :colors="colors" score-template="">
            </el-rate>
          </div>
        </div>
        <div class="time">{{ item.createTime }}</div>
        <div class="evaluate-content">
          {{ item.content }}
        </div>
        <!-- <div class="time-report">
          <div class="report-icon" @click="handleReport(item)">
            <img :src="require('@/assets/icon/report' +
              (item.reportCount == 0 ? '.png' : 'ed.png'))
              " alt="" />
            <span :class="item.reportCount == 0 ? '' : 'red'">{{
              item.reportCount == 0 ? "举报" : "已举报"
            }}</span>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 举报对话框 -->
    <el-dialog title="举报" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <div class="report-title">
          <span>举报内容</span>
        </div>
        <div>
          <el-input v-model.trim="form.reportContent" placeholder="请输入举报内容" type="textarea" :rows="5" maxlength="250"
            auto-complete="off" show-word-limit />
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelReport">取 消</el-button>
        <el-button type="primary" @click="submitReport()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { reportComment } from "@/api/bookstore/bookstore";
export default {
  data() {
    return {
      defaultAvatar: require("@/assets/images/default-avatar.jpg"),
      colors: ["#F7BA1E", "#F7BA1E", "#F7BA1E"],
      dialogFormVisible: false,
      form: {
        evaluateId: 0,
        orderId: 0,
        relevanceId: 0,
        reportContent: "",
      },
    };
  },
  props: {
    dataList: Array,
  },
  methods: {
    //打开举报对话框
    handleReport(item) {
      this.form = {};
      this.form.evaluateId = item.id;
      this.form.orderId = item.orderId;
      this.form.relevanceId = item.relevanceId;
      this.dialogFormVisible = true;
    },
    //提交举报
    submitReport() {
      let userId = this.$store.getters.userId;
      if (!userId) {
        this.$router.push({
          path: "/login",
        });
      } else {
        if (this.form.reportContent == null || this.form.reportContent == "") {
          this.$message("举报内容不能为空");
          return;
        } else {
          reportComment(this.form).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "举报成功",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.$emit("refreshList2");
            }
          });
        }
      }
    },
    //取消举报
    cancelReport() {
      this.dialogFormVisible = false;
      this.form = {};
    },
  },
};
</script>

<style scoped lang='scss'>
.evaluate-list {
  padding-top: 10px;
  .evaluate-box {
    display: flex;
    // padding: 15px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 24px;

    .user-img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      margin-right: 12px;

      img {
        max-width: 32px;
        max-height: 32px;
        border-radius: 50%;
      }
    }

    .evaluate-info {
      width: 100%;

      .name-score {
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;

        .name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
      }

      .time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
        margin-bottom: 12px;
      }

      .evaluate-content {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        margin-bottom: 20px;
        word-break: break-all;
      }

      .time-report {
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .time {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .report-icon {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          cursor: pointer;

          img {
            width: 11px;
            height: 11px;
          }

          .red {
            color: #d81e06;
          }
        }
      }
    }
  }
}

::v-deep .el-dialog {
  width: 40%;

  .el-dialog__header {
    background: #f0f2f5;
  }

  .report-title {
    margin-bottom: 10px;
  }
}

.el-textarea__inner {
  resize: none;
}
</style>